import homepage from './homepage';
import detectVideo from './jsVideo';

// run all related funcs here
const runFuncs = () => {
  homepage();
  detectVideo();
};

export default runFuncs;
